import { Box, Card, Group, Stack, Text } from '@mantine/core'
import { formatEuros } from '@markku/utils'
import { CategoryData } from './utils'

interface CostsCategoryListProps {
  categories: CategoryData[]
}

export function CostsCategoryList({ categories }: CostsCategoryListProps) {
  if (!categories.length) return null

  return (
    <Card withBorder radius="lg" p="md">
      <Stack gap="md">
        <Text fw={600} size="sm">
          Kustannukset kategorioittain
        </Text>

        <Stack gap="sm">
          {categories.slice(0, 5).map((cat) => (
            <Group key={cat.category} justify="space-between">
              <Group gap="xs">
                <Box
                  style={{
                    width: 12,
                    height: 12,
                    borderRadius: 3,
                    background: `var(--mantine-color-${cat.color})`,
                  }}
                />
                <Text size="sm">{cat.category}</Text>
              </Group>
              <Text size="sm" fw={600}>
                {formatEuros(cat.cost)}
              </Text>
            </Group>
          ))}
        </Stack>
      </Stack>
    </Card>
  )
}
